import gql from "graphql-tag";

export default gql`
  fragment FinancialSegmentsFields on FinancialSegments {
    periodEndingDate
    currency
    segments {
      name
      isPrimary
      ratioAdjustedIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
      financialIndicators {
        name
        value
        history {
          periodEndingDate
          value
        }
      }
    }
  }
`;
